class SpliderComponent extends HTMLElement {
  constructor() {
    super();
    this.options = JSON.parse(this.dataset.options || "{}");
  }

  connectedCallback() {
    // Initialize immediately if document is already loaded
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.initSplide());
    } else {
      this.initSplide();
    }
  }

  initSplide() {
    this.splide = new Splide(this, this.options).mount();
  }
}

customElements.define("splider-component", SpliderComponent);
